import { css, Interpolation, Theme } from '@emotion/react';
import { theme } from '@frontend/theme';
import { PopoverMenu, useModalControl, usePopoverMenu } from '@frontend/design-system';
import { useCalendarStore } from '../../stores';
import { FilterButton } from './filter-button';
import { FilterDrawer } from './filter-drawer';
import { PopoverFilterPanelContent } from './popover-filter-panel-content';

interface Props {
  filterContentVariant: 'drawer' | 'popover';
  iconOnly?: boolean;
  trackingId?: string;
  buttonStyles?: Interpolation<Theme>;
}

export const AppointmentListFilterButton = ({
  iconOnly = false,
  filterContentVariant = 'drawer',
  trackingId,
  buttonStyles,
}: Props) => {
  const { getMenuProps, getTriggerProps, close } = usePopoverMenu({ placement: 'bottom-end' });
  const modalControl = useModalControl({ disableReturnFocus: true });
  const {
    calendarApptStatuses,
    calendarProviderIds,
    calendarApptTypeIds,
    calendarOperatories,
    calendarInsuranceStatuses,
  } = useCalendarStore([
    'calendarApptStatuses',
    'calendarProviderIds',
    'calendarApptTypeIds',
    'calendarOperatories',
    'calendarInsuranceStatuses',
  ]);

  const hasCalendarFilters =
    calendarProviderIds.length > 0 ||
    calendarApptTypeIds.length > 0 ||
    calendarApptStatuses.length > 0 ||
    calendarOperatories.length > 0 ||
    calendarInsuranceStatuses.length > 0;

  const isDrawer = filterContentVariant === 'drawer';

  return (
    <>
      <FilterButton
        iconOnly={iconOnly}
        shouldShowDot={hasCalendarFilters}
        trackingId={trackingId}
        css={buttonStyles}
        {...(isDrawer ? { onClick: modalControl.openModal } : { getTriggerProps })}
      />
      <PopoverMenu css={popoverMenuStyle} {...getMenuProps()}>
        <PopoverFilterPanelContent onClose={close} />
      </PopoverMenu>
      <FilterDrawer {...modalControl.modalProps} />
    </>
  );
};

const popoverMenuStyle = css({
  borderRadius: theme.borderRadius.small,
  padding: theme.spacing(1),
});
